module.exports = __webpack_public_path__ + "img/icon-cargo-disable.54ed8cb5.svg";